import './DealIdCell.scss';

import { Link } from '@hulu/react-router-dom';
import { bem } from 'mission-control-common-components';
import { memo } from 'react';

import { LineItemSsp } from '../../../../../apis/graphql';
import type { Nullable } from '../../../../../models';

export type DealIdCellProps = {
  dealId?: Nullable<string>;
  ssp?: Nullable<LineItemSsp>;
  metadataDealId?: Nullable<string>;
};

const [, element] = bem('deal-id-cell');

const DealIdCell = ({ dealId, ssp, metadataDealId }: DealIdCellProps): React.JSX.Element | null => {
  return dealId && metadataDealId && ssp === LineItemSsp.Drax ? (
    <Link
      target="_blank"
      rel="noopener noreferrer"
      className={element('link')}
      to={`/demand-management/deals/${dealId}`}
      data-testid="deal-id-link"
    >
      {metadataDealId}
    </Link>
  ) : (
    <span data-testid="deal-id-label">{metadataDealId}</span>
  );
};

export default memo(DealIdCell);
